<div class="po">
  <!-- 1 · heading block -->
  <div class="po__hd">
    <div class="po__eb">{{ 'app.pages.auth.walkthrough.pane1.eyebrow' | translate }}</div>
    <h2 class="po__h2">{{ 'app.pages.auth.walkthrough.pane1.title' | translate }}</h2>
    <p class="po__p">{{ 'app.pages.auth.walkthrough.pane1.body' | translate }}</p>
  </div>

  <!-- 2 · the two no-code engines. 2-up at `pane-engine` (620px). -->
  <div class="po__eng">
    @for (engine of engines; track engine.titleKey) {
      <div class="po__e">
        <div class="po__et">
          <ion-icon [name]="engine.icon" aria-hidden="true"></ion-icon>
          <span>{{ engine.titleKey | translate }}</span>
        </div>
        <div class="po__ed">{{ engine.bodyKey | translate }}</div>
      </div>
    }
  </div>

  <!-- 3 · label -->
  <div class="po__lbl">{{ 'app.pages.auth.walkthrough.pane1.modules.label' | translate }}</div>

  <!-- 4 · fourteen module chips. INERT — `<div>`, no handler, nothing focusable:
       these illustrate modules, they do not launch them (§12 #16). -->
  <div class="po__grid">
    @for (mod of modules; track mod.labelKey) {
      <div class="po__m">
        <ion-icon [name]="mod.icon" aria-hidden="true"></ion-icon>
        <span>{{ mod.labelKey | translate }}</span>
      </div>
    }
  </div>

  <!-- 5 · the no-ERP-bloat call-out. Its three items go 3-up at `pane-cards`. -->
  <div class="po__pd">
    <div class="po__pdt">
      <ion-icon name="funnel-outline" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane1.noBloat.title' | translate }}</span>
    </div>
    <div class="po__pdr">
      @for (item of noBloat; track item.labelKey) {
        <span class="po__pdi">
          <ion-icon [name]="item.icon" aria-hidden="true"></ion-icon>
          <span>{{ item.labelKey | translate }}</span>
        </span>
      }
    </div>
  </div>

  <!-- 6 · four pills above a rule. The same component Login and Signup project
       into their pitch column — one marketing pill, three call sites. -->
  <div class="po__foot">
    @for (pill of pills; track pill.labelKey) {
      <app-auth-pitch-pill [icon]="pill.icon">{{ pill.labelKey | translate }}</app-auth-pitch-pill>
    }
  </div>
</div>
